// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATION_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};
